import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sentancecase',
  standalone: false
})
export class SentanceCasePipe implements PipeTransform {
  transform(value: string): string | undefined {
    if (!value) {
      return undefined;
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
